import axios, { AxiosInstance } from "axios";
import { API_URL } from "constants/api";
import { appStore } from "store";
import { userStore } from "store/user";
import { BonusProgram, ReferralProgram, Round, Settings } from "types";
import { TClaimOrder } from "types/claim";
import {
  IPaymentLimit,
  Order,
  OrdersResponse,
  SaleProgressResponse,
} from "types/Tokens";

export class ClaimService {
  private _api: AxiosInstance;

  constructor() {
    this._api = axios.create({
      baseURL: API_URL,
      withCredentials: true,
    });
  }

  async createClaimRequest(
    walletAddress: string,
    amount: string
  ): Promise<TClaimOrder | null> {
    try {
      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        throw new Error("No access token");
      }

      const { data } = await this._api.post<TClaimOrder>(
        "/api/claim-orders",
        { walletAddress, amount },
        {
          headers: {
            authorization: accessToken,
          },
        }
      );

      return data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async convertEarnings(): Promise<TClaimOrder | null> {
    try {
      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        throw new Error("No access token");
      }

      const { data } = await this._api.post<TClaimOrder>(
        "/api/orders/convert/referral-earnings",
        {},
        {
          headers: {
            authorization: accessToken,
          },
        }
      );

      return data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }
}

export const claimService = new ClaimService();
